import { Vue } from "vue-property-decorator";
import { EventBus } from "@/components/EventBus";
import { ApiError } from "@/services/BaseService";
import { DataClient } from "@/services/DataClient";

export class BaseView extends Vue {

    get instanceName(): string {
        const host = window.location.hostname;

        const isAspro = host.includes("aspro");
        if (isAspro) {
            return "aspro";
        }

        return "";
    }

    get isMobile() {
        return this.$vuetify.breakpoint.smAndDown;
    }

    async sleep(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    scrollToTop() {
        EventBus.$emit("scrollToTop");
    }

    getErrorMessageFromException(error: any): string {
        let message = "";
        if (error instanceof ApiError) {
            message = error.errorMessage;
        } else if (error instanceof Error) {
            message = error.message;
        } else {
            message = error;
        }

        message = message || "Error desconocido";

        return message;
    }

    async openErrorDialog(error: any): Promise<void> {
        const message = this.getErrorMessageFromException(error);

        await DataClient.Dialogs.confirmation({
            title: "Error durante la operación",
            message: "Ha ocurrido un error durante la operación. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, contacte con el administrador del sistema.",
            messages: [
                "El mensaje de error devuelto por el sistema es el siguiente:",
                "<strong>" + message + "</strong>"
            ],
            nocancel: true,
            icon: "mdi-alert-circle-outline",
            iconColor: "error",
            color: "error",
            buttonColor: "error",
        });
    }

    dump(data: any) {
        console.log("Dump", data);
    }


}
